<template>
  <el-card class="box-card" v-loading="myLoading">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span style="font-size: 24px">{{ $t('模型列表.模型列表') }}</span>
      <div class="head-text" style="float: right; margin-top: -4px">
        <el-button type="warning" @click="modelRecord" style="margin-right: 5px">{{ $t('模型列表.转换记录') }}</el-button>
        <!-- <el-button type="primary" @click="uploadModel" style="margin-right: 20px"
          v-if="permissions != null && permissions.indexOf('scmx') > -1">{{ $t('模型列表.上传模型') }}</el-button> -->
        <el-input :placeholder="$t('模型列表.请输入模型名称')" class="search-input" v-model="modelQuery"
          style="width: 200px"></el-input>
        <el-button icon="el-icon-search" @click="modelList"></el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table height="72vh" v-loading="loading" :data="modelList1" style="width: 100%">
      <el-table-column align="center" type="selection" width="55"></el-table-column>
      <<el-table-column align="center" type="index" :label="$t('模型列表.序号')" width="80"></el-table-column>
        <el-table-column align="center" prop="mode02" :label="$t('模型列表.文件名称')"></el-table-column>
        <el-table-column align="center" prop="mode10" :label="$t('模型列表.文件大小')">
          <template slot-scope="scope">{{ Math.floor(scope.row.mode10 / 1024 / 1024) }}MB</template>
        </el-table-column>
        <el-table-column align="center" prop="mode04" :label="$t('模型列表.上传文件大小')">
          <template slot-scope="scope">{{ Math.floor(scope.row.mode04 / 1024 / 1024) }}MB</template>
        </el-table-column>
        <el-table-column align="center" prop="mode05" :label="$t('模型列表.版本备注')"></el-table-column>
        <el-table-column align="center" prop="mode06" :label="$t('模型列表.联系人')"></el-table-column>
        <el-table-column align="center" prop="mode07" :label="$t('模型列表.邮箱')"></el-table-column>
        <el-table-column align="center" prop="mode08" :label="$t('模型列表.电话')"></el-table-column>
        <el-table-column align="center" prop="mode03" :label="$t('模型列表.备注')"></el-table-column>
        <el-table-column align="center" prop="pname" :label="$t('模型列表.所属项目')"></el-table-column>
        <el-table-column align="center" prop="mode11" :label="$t('模型列表.更新时间')" sortable></el-table-column>
        <el-table-column align="center" :label="$t('模型列表.操作')" min-width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="modelView(scope.row)">{{ $t('模型列表.浏览')
            }}</el-button>
            <!-- <el-button
            plain
            style="margin-top: 3px"
            size="small"
            @click="guishuShow(scope.row)"
            type="primary"
            >归属</el-button
          >
          <el-button
            size="small"
            type="success"
            @click="btnShow(scope.$index, scope.row)"
            >更多</el-button
          >
          <div v-show="scope.row.btnMore">
            <el-button
              plain
              style="margin-top: 3px"
              size="small"
              @click="deleteModel(scope.row)"
              type="primary"
              >删除</el-button
            >
            <el-button
              plain
              style="margin-top: 3px"
              size="small"
              @click="copyModelShow(scope.row)"
              type="primary"
              >复制</el-button
            >
            <el-button
              plain
              style="margin-top: 3px"
              size="small"
              @click="downloadNew(scope.row)"
              type="primary"
              >下载</el-button
            >
            <el-button
              plain
              style="margin-top: 3px"
              size="small"
              @click="banbenShow(scope.row)"
              type="primary"
              >版本</el-button
            >
            <el-button
              size="mini"
              type="primary"
              style="margin-top: 3px"
              plain
              @click="editModelDetil(scope.row)"
              v-if="permissions != null && permissions.indexOf('scmx') > -1"
              >修改</el-button
            >
            <el-button
              size="mini"
              type="primary"
              style="margin-top: 3px"
              plain
              @click="updateData(scope.row)"
              >更新数据</el-button
            >
          </div> -->
          </template>
        </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination align="center" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-sizes="[100, 50, 10]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <!-- 版本 -->
    <el-dialog title="版本" :visible.sync="banben" width="60%">
      <el-table v-loading="loading" :data="modelList2" style="width: 100%" max-height="500">
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column align="center" prop="mode02" label="文件名称"></el-table-column>
        <el-table-column align="center" prop="mode10" label="文件大小">
          <template slot-scope="scope">{{ Math.floor(scope.row.mode10 / 1024 / 1024) }}MB</template>
        </el-table-column>
        <el-table-column align="center" prop="mode04" label="上传文件大小">
          <template slot-scope="scope">{{ Math.floor(scope.row.mode04 / 1024 / 1024) }}MB</template>
        </el-table-column>
        <el-table-column align="center" prop="mode05" label="版本备注"></el-table-column>
        <el-table-column align="center" prop="mode06" label="联系人"></el-table-column>
        <el-table-column align="center" prop="mode07" label="邮箱"></el-table-column>
        <el-table-column align="center" prop="mode08" label="电话"></el-table-column>
        <el-table-column align="center" prop="mode03" label="备注"></el-table-column>
        <el-table-column align="center" label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="small" @click="modelVersionView(scope.row)" type="primary">浏览</el-button>
            <el-button size="small" @click="download(scope.row)" type="primary">下载</el-button>
            <el-button size="small" @click="DelModelfileVersion(scope.row)" type="primary">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 转换记录 -->
    <el-dialog :title="$t('模型列表.转换记录')" :visible.sync="modelRecordShow" width="65%">
      <el-table v-loading="loading" :data="modelRecordList" style="width: 100%" max-height="500">
        <el-table-column type="index" width="50" :label="$t('模型列表.序号')"></el-table-column>
        <el-table-column align="center" prop="mdst03" :label="$t('模型列表.文件名称')"></el-table-column>
        <el-table-column align="center" prop="mdst09" :label="$t('模型列表.上传文件大小')">
          <template slot-scope="scope">{{
            Math.floor(scope.row.mdst09 / 1024 / 1024).toFixed(2)
          }}MB</template>
        </el-table-column>
        <el-table-column align="center" prop="mdst08" :label="$t('模型列表.转换类型')">
          <template slot-scope="scope">{{
            scope.row.mdst08 == 0 ? $t('模型列表.上传模型') : $t('模型列表.更新模型')
          }}</template>
        </el-table-column>
        <el-table-column align="center" prop="mdst05" :label="$t('模型列表.转换状态')">
          <template slot-scope="scope">
            <span :style="{
              color:
                scope.row.mdst05 == 0
                  ? '#e6a23c'
                  : scope.row.mdst05 == 1
                    ? '#f56c6c'
                    : scope.row.mdst05 == 2
                      ? '#67c23a'
                      : 'black',
            }">
              {{
                scope.row.mdst05 == 0
                  ? $t('模型列表.转换中')
                  : scope.row.mdst05 == 1
                    ? $t('模型列表.转换失败')
                    : scope.row.mdst05 == 2
                      ? $t('模型列表.转换成功')
                      : "--"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="Minute" :label="$t('模型列表.用时') + '(min)'"></el-table-column>
        <el-table-column align="center" prop="mdst04" :label="$t('模型列表.联系人')"></el-table-column>
        <el-table-column align="center" prop="mdst06" :label="$t('模型列表.创建时间')"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 归属 -->
    <el-dialog title="归属" :visible.sync="guishu" width="30%">
      <el-table v-loading="loading" :data="projectList">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column align="center" prop="proj03" label="项目名称"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 选择上传模式 -->
    <el-dialog :title="$t('模型列表.选择上传模型的类型')" :visible.sync="changUploadModel" width="30%">
      <div class="changUpload">
        <div class="ZIP" @click="updataModelShow">
          <p>{{ $t('模型列表.上传SVFZIP文件') }}</p>
          <img src="@/assets/img/upload.png" alt />
          <p>{{ $t('模型列表.通过AUTODESK云端进行轻量化转后的文件') }}</p>
        </div>
        <div class="REVIT" @click="updataModelShowREVIT" v-if="permissions != null && permissions.indexOf('zhmx') > -1">
          <p>{{ $t('模型列表.上传REVITNAVISWORKS文件并转化') }}</p>
          <img src="@/assets/img/upload.png" alt />
          <p>{{ $t('模型列表.上传到服务器并进行模型转换时间较长请耐心等待') }}</p>
        </div>
      </div>
    </el-dialog>
    <!-- 选择修改模式 -->
    <el-dialog title="选择上传模型的类型" :visible.sync="changEditUploadModel" width="30%">
      <div class="changUpload">
        <div class="ZIP" @click="updataEditModelShow">
          <p>上传SVFZIP文件</p>
          <img src="@/assets/img/upload.png" alt />
          <p>通过AUTODESK云端进行轻量化转后的文件</p>
        </div>
        <div class="REVIT" @click="updataEditModelShowREVIT"
          v-if="permissions != null && permissions.indexOf('zhmx') > -1">
          <p>上传REVIT/NAVISWORKS文件并转化</p>
          <img src="@/assets/img/upload.png" alt />
          <p>最高支持2021版本文件</p>
        </div>
      </div>
    </el-dialog>
    <!-- 这里是新增模型updataModel1 -->
    <el-dialog :title="updataModelTitle" :visible.sync="updataModel1" width="50%">
      <el-form :model="addModelList" label-width="150px" ref="addModelList" v-loading="loading2">
        <el-form-item :label="$t('模型列表.文件名称')" prop="mode02">
          <el-input v-model="addModelList.mode02" auto-co vmplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('模型列表.版本备注')" prop="mode05">
          <el-input v-model="addModelList.mode05" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('模型列表.联系人')" prop="mode06">
          <el-input v-model="addModelList.mode06" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('模型列表.邮箱')" prop="mode07">
          <el-input v-model="addModelList.mode07" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('模型列表.电话')" prop="mode08">
          <el-input v-model="addModelList.mode08" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('模型列表.备注')" prop="mode03">
          <el-input v-model="addModelList.mode03" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('模型列表.模型文件')" prop="mode09">
          <el-upload ref="upload" class="upload-demo" :action="actionUrl" :on-change="handleChange"
            :file-list="fileList" :limit="1" :data="addModelList" :before-upload="beforeUpload" :accept="accept"
            :auto-upload="false" :on-success="uploadSuccess" :headers="importHeaders" :on-exceed="handleExceed"
            :on-error="uploadError">
            <el-button size="small" type="primary">{{ $t('模型列表.点击上传') }}</el-button>
            <div slot="tip" class="el-upload__tip">
              <!-- 只能上传{{ this.uploadType }}文件，且不超过1G -->
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-row>
        <el-col :span="6" :offset="6">
          <el-button type="primary" @click="addModel">{{ $t('common.确定') }}</el-button>
        </el-col>
        <el-col :span="6">
          <el-button @click="updataModel1 = false">{{ $t('common.取消') }}</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 这里是模型修改 -->
    <el-dialog :title="updataEditModelTitle" :visible.sync="editModel1" width="50%">
      <el-form :model="editModel" label-width="80px" ref="editModel" v-loading="editModelLoading">
        <el-form-item label="文件名称" prop="mode02">
          <el-input v-model="editModel.mode02" auto-co vmplete="off" placeholder="请输入文件名称"></el-input>
        </el-form-item>
        <el-form-item label="版本备注" prop="mode05">
          <el-input v-model="editModel.mode05" auto-complete="off" placeholder="请输入版本备注"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="mode06">
          <el-input v-model="editModel.mode06" auto-complete="off" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系邮箱" prop="mode07">
          <el-input v-model="editModel.mode07" auto-complete="off" placeholder="请输入联系邮箱"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mode08">
          <el-input v-model="editModel.mode08" auto-complete="off" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="mode03">
          <el-input v-model="editModel.mode03" auto-complete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="模型文件" prop="mode09">
          <el-upload ref="editModelList" class="upload-demo" :action="editModelActionUrl"
            :on-change="editModelHandleChange" :file-list="editModelFileList" :limit="1" :data="editModel"
            :before-upload="editModelBeforeUpload" :accept="accept" :auto-upload="false"
            :on-success="editModelUploadSuccess" :headers="importHeaders" :on-exceed="handleExceed"
            :on-error="uploadError">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传{{ this.uploadType }}文件，且不超过500M
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-row>
        <el-col :span="6" :offset="6">
          <el-button @click="editModelList">确定</el-button>
        </el-col>
        <el-col :span="6">
          <el-button @click="editModel1 = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 模型复制 -->
    <el-dialog title="模型复制" :visible.sync="copyModelVisible" width="30%">
      <el-card class="box-card" style="height: 300px; height: 250px; margin: 10px">
        <el-form style="margin-left: 80px" ref="copyModelList" :model="copyModelList" label-width="80px">
          <el-form-item label="重新命名">
            <el-input style="width: 65%" v-model="copyModelList.name"></el-input>
          </el-form-item>
          <el-form-item label="选择项目">
            <el-select v-model="copyModelList.xid" placeholder="请选择">
              <el-option v-for="item in projectList" :key="item.proj01" :label="item.proj03"
                :value="item.proj01"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="12" style="text-align: center">
            <el-button style="width: 50%" size="small" type="primary" @click="CopyModel">确认</el-button>
          </el-col>
          <el-col :span="12" style="text-align: center">
            <el-button style="width: 50%" size="small" type="danger" @click="copyModelVisible = false">取消</el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  GetModelList,
  GetModelLinkProjectList,
  GetModelVersionsList,
  DownModel,
  GetCompanyinfo,
  CopyModel,
  GetCompanyProjectList,
  DelModelFile,
  DelModelfileVersion,
  UpdateModelFile,
  GetModelStateList,
} from "@/setAxios";
export default {
  data() {
    return {
      modelRecordShow: false,
      modelRecordList: [],
      myLoading: false,
      changEditUploadModel: false,
      editModel1: false,
      editModelLoading: false,
      updataEditModelTitle: "",
      editModel: {
        mode01: "",
        mode02: "",
        mode03: "",
        mode04: "",
        mode05: "",
        mode06: "",
        mode07: "",
        mode08: "",
        mode09: "",
        mode13: "",
      },
      editModelFileList: [],
      editModelActionUrl: "",
      permissions: "",
      loading2: false,
      updataModel1: false,
      changUploadModel: false,
      copyModelVisible: false,
      updataModelTitle: "",
      uploadType: "",
      accept: "",
      actionUrl: "",
      fileList: [],
      importHeaders: { token: localStorage.getItem("token") },
      addModelList: {
        mode02: "",
        mode03: "",
        mode04: "",
        mode05: "",
        mode06: "",
        mode07: "",
        mode08: "",
        mode09: "",
        mode13: "",
      },
      copyModelList: {
        name: "",
        cid: localStorage.getItem("pid"),
        xid: "",
        mid: "",
      },
      guishu: false,
      banben: false,
      modelQuery: "",
      loading: false,
      modelList1: [],
      modelList2: [],
      projectList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      mid: null,
      nvtypes: [
        ".nwc",
        ".nwf",
        ".nwd",
        ".3ds",
        ".dgn",
        ".dwf",
        ".dwg",
        ".dxf",
        ".fbx",
        ".ifc",
        ".rvt",
        ".rfa",
        ".rte",
        ".3dm",
        ".skp",
      ],
    };
  },
  created() {
    this.modelList();
    let params = {
      cid: localStorage.getItem("pid"),
    };
    GetCompanyinfo({ params }).then((res) => {
      this.permissions = res.Data.comp13;
    });
  },
  methods: {
    async modelRecord() {
      this.loading = true;
      let params = {
        qid: localStorage.getItem("pid"),
      };
      let res = await GetModelStateList({ params });
      this.loading = false;
      this.modelRecordShow = true;
      this.modelRecordList = res.Data;
    },

    btnShow(index, row) {
      this.modelList1[index].btnMore = !this.modelList1[index].btnMore;
      this.modelList1 = JSON.parse(JSON.stringify(this.modelList1));
    },
    async download(row) {
      this.myLoading = true;
      let params = {
        id: row.mode01,
      };
      let res = await DownModel(params);
      this.myLoading = false;
      if (res.Code == 1) {
        let httpUrl = this.$store.state.baseUrl + res.Data;
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = httpUrl;
        document.body.appendChild(link);
        link.click();
      } else {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      }
    },
    async downloadNew(row) {
      this.myLoading = true;
      let params = {
        id: row.mode01,
      };
      let res = await DownModel(params);
      this.myLoading = false;
      if (res.Code == 1) {
        let httpUrl = this.$store.state.baseUrl + res.Data;
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = httpUrl;
        document.body.appendChild(link);
        link.click();
      } else {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      }
    },
    // 编辑模型
    editModelDetil(row) {
      this.changEditUploadModel = true;
      this.editModel = JSON.parse(JSON.stringify(row));
    },
    updataEditModelShow() {
      this.editModel1 = true;
      this.updataEditModelTitle = "上传SVFZIP文件";
      this.uploadType = ".svfzip,.zip";
      this.accept = ".svfzip,.zip";
      this.editModelActionUrl =
        this.$store.state.baseUrl + "/api/UpdateModelFile";
    },
    updataEditModelShowREVIT() {
      this.editModel1 = true;
      this.updataEditModelTitle = "上传RVT,NWD文件";
      this.uploadType = this.nvtypes.join(",");
      this.accept = this.nvtypes.join(",");
      this.editModelActionUrl =
        this.$store.state.baseUrl + "/api/UpdateModelRvt";
    },
    editModelHandleChange(file, fileList) {
      this.editModelFileList = fileList.slice(-3);
    },
    editModelUploadSuccess(res) {
      this.editModelLoading = false;
      this.editModel1 = false;
      this.$message({
        type: res.Code > 0 ? "success" : "error",
        message: res.Message,
      });
      this.modelList();
    },
    editModelList() {
      let params = JSON.stringify(this.editModel);
      if (this.editModelFileList.length > 0) {
        this.$refs.editModelList.submit();
        this.editModelLoading = true;
      } else {
        let fd = new FormData();
        for (var key in this.editModel) {
          fd.append(key, this.editModel[key]);
        }
        UpdateModelFile(fd).then((res) => {
          this.$message({
            type: res.Code == 1 ? "success" : "warning",
            message: res.Message,
          });
          this.editModel1 = false;
          this.changEditUploadModel = false;
          this.modelList();
        });
      }
    },
    editModelBeforeUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("editModel", JSON.stringify(this.editModel));
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix.toLowerCase();
      const isLt500M = file.size / 1024 / 1024 <= 1024;
      if (this.uploadType.indexOf(extension) == -1) {
        this.$message({
          message: `上传文件只能是${this.uploadType}格式!`,
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt500M) {
        this.$message({
          message: "上传文件大小不能超过1G!",
          type: "warning",
        });
      }
      return extension || isLt500M;
    },
    async copyModelShow(data) {
      this.copyModelVisible = true;
      this.copyModelList.mid = data.mode01;
      let params = {
        seachword: "",
        bid: "null",
        pageIndex: 1,
        pageSize: 10000000,
        qid: localStorage.getItem("pid"),
      };
      let res = await GetCompanyProjectList({ params });
      this.projectList = res.Data.lsit;
    },
    async CopyModel() {
      let res = await CopyModel(this.copyModelList);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "复制成功",
        });
        this.copyModelVisible = false;
        this.modelList();
      } else {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      }
    },
    // 这里上传模型
    addModel() {
      this.addModelList.mode13 = localStorage.getItem("pid");
      let params = JSON.stringify(this.addModelList);
      if (this.fileList.length > 0) {
        this.$refs.upload.submit();
        this.loading2 = true;
      } else {
        this.$message({
          type: "warning",
          message: this.$t('模型列表.请选择文件后上传'),
        });
      }
    },
    uploadModel() {
      this.changUploadModel = true;
    },
    updataModelShow() {
      this.updataModel1 = true;
      this.updataModelTitle = this.$t('模型列表.上传SVFZIP文件');
      this.uploadType = ".svfzip,.zip";
      this.accept = ".svfzip,.zip";
      this.actionUrl = this.$store.state.baseUrl + "/api/UploadModelFile";
    },
    updataModelShowREVIT() {
      this.updataModel1 = true;
      this.updataModelTitle = this.$t('模型列表.上传RVTNWD文件');
      this.uploadType = this.nvtypes.join(",");
      this.accept = this.nvtypes.join(",");
      this.actionUrl = this.$store.state.baseUrl + "/api/UploadModelRvt";
    },
    // 上传模型
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    beforeUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("addModelList", JSON.stringify(this.addModelList));
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix.toLowerCase();
      const isLt500M = file.size / 1024 / 1024 <= 1024;
      if (this.uploadType.indexOf(extension) == -1) {
        this.$message({
          message: `上传文件只能是${this.uploadType}格式!`,
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt500M) {
        this.$message({
          message: "上传文件大小不能超过500MB!",
          type: "warning",
        });
      }
      return extension || isLt500M;
    },
    // 上传成功
    uploadSuccess(code) {
      this.loading2 = false;
      this.updataModel1 = false;
      this.$message({
        type: code.Code > 0 ? "success" : "error",
        message: code.Message,
      });
      this.modelList();
    },
    uploadError() {
      this.loading2 = false;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    async guishuShow(row) {
      this.mode01 = row.mode01;
      this.GetModelLinkProjectList();
      this.guishu = true;
    },
    async GetModelLinkProjectList() {
      let params = { mid: this.mode01 };
      let res = await GetModelLinkProjectList(params);
      this.projectList = res.Data;
    },
    banbenShow(row) {
      this.mid = row.mode15;
      this.GetModelVersionsList();
      this.banben = true;
    },
    async GetModelVersionsList() {
      let params = { mid: this.mid };
      let res = await GetModelVersionsList(params);
      this.modelList2 = res.Data;
    },
    deleteModel(row) {
      this.$confirm("此操作将永久删除该模型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: row.mode01,
        };
        DelModelFile(params).then((res) => {
          if (res.Code) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.modelList();
          }
        });
      });
    },
    // 删除历史Model
    DelModelfileVersion(row) {
      this.$confirm("此操作将永久删除该模型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: row.mode01,
        };
        DelModelfileVersion(params).then((res) => {
          if (res.Code === 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.GetModelVersionsList();
          }
        });
      });
    },
    // 浏览模型
    modelView(row) {
      let params = `modelId=${row.mode01}^@^type=viewModel`;
      params = Base64.encode(params);
      let url = window.location.origin + `/#/viewModel?Code=${params}`;
      window.open(url);
    },
    // 更新数据
    updateData(row) {
      let params = `modelId=${row.mode01}^@^type=UpdateData`;
      params = Base64.encode(params);
      let url = window.location.origin + `/#/viewModel?Code=${params}`;
      window.open(url);
    },
    //历史版本浏览模型
    modelVersionView(row) {
      let params = `modelId=${row.mode01}^@^type=viewModel`;
      params = Base64.encode(params);
      let url = window.location.origin + `/#/viewModel?Code=${params}`;
      window.open(url);
    },
    // 显示模型管理器页面
    modelList() {
      let params = {
        bid: localStorage.getItem("pid"),
        seachword: this.modelQuery,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      GetModelList({ params }).then((res) => {
        this.modelList1 = res.Data.list;
        this.modelList1.forEach((v) => {
          v.btnMore = false;
        });
        this.total = res.Data.total;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.modelList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.modelList();
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 80px;
  margin-top: 10px;
}

.changUpload {
  height: 50vh;
  text-align: center;

  .ZIP {
    width: 35%;
    height: 100%;
    margin-left: 10%;
    float: left;
    border: 2px solid #eee;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;

    p {
      font-size: 14px;
      margin-top: 30px;
      height: 50px;
    }

    img {
      width: 100px;
      margin-top: 50px;
    }
  }

  .ZIP:hover {
    background: #eee;
    border-color: skyblue;
  }

  .REVIT:hover {
    background: #eee;
    border-color: skyblue;
  }

  .REVIT {
    width: 35%;
    height: 100%;
    float: left;
    margin-left: 5%;
    border: 2px solid #eee;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;

    p {
      font-size: 14px;
      margin-top: 30px;
      height: 50px;
    }

    img {
      width: 100px;
      margin-top: 50px;
    }
  }
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #cdcdcd;
  padding: 20px;
}
</style>
